import { useTableContext } from "@/common/contexts/Table.context";
import { Checkbox, Divider, Dropdown, MenuProps } from "antd";
import { useEffect, useState } from "react";
import { SettingsIcon } from "../../icon";
import { filtersLabels } from "@/common/const/filter-options";
import CustomTypography from "@/components/Typography/CustomTypography";

export default function FilterSelect<T>({
  fieldName,
  values,
}: {
  fieldName: string;
  values: { label: string; value: string }[];
}) {
  const [selectedKeys, setSelectedKeys] = useState<T[]>([]);
  const { changeFilters, filters } = useTableContext();

  useEffect(() => {
    const [parentKey, childKey] = fieldName.split("-");
    if (!filters[parentKey]) return setSelectedKeys([]);
    setSelectedKeys((filters[parentKey][childKey] as T[]) || []);
  }, [filters]);

  const handleMenuClick = (key: T) => {
    const newSelectedKeys = selectedKeys.includes(key)
      ? selectedKeys.filter((k) => k !== key)
      : [...selectedKeys, key];
    changeFilters(fieldName, newSelectedKeys as unknown as string);
  };
  const menuItems: MenuProps["items"] = values.map((el, index) => ({
    key: el.value,
    label: (
      <div onClick={() => handleMenuClick(el.value as T)}>
        <div className="flex gap-2 items-center">
          <Checkbox checked={selectedKeys.includes(el.value as T)} />
          <CustomTypography as="span" weight={"light"} size={"13px"}>
            {el.label}
          </CustomTypography>
        </div>

        {index + 1 !== values.length && (
          <Divider
            orientationMargin={0}
            className="!my-0 !w-[133%] !-ml-[17%] !mt-1"
          />
        )}
      </div>
    ),
  }));

  return (
    <div className="-mb-7 h-full w-full flex justify-left  gap-2 items-center ">
      <CustomTypography
        as="span"
        size={"13px"}
        color={"gray"}
        className="text-nowrap"
        case={"uppercase"}
      >
        {filtersLabels[fieldName]}
      </CustomTypography>
      <Dropdown className="" menu={{ items: menuItems }} trigger={["click"]}>
        <div className="text-gray-dim rotate-90 cursor-pointer">
          <SettingsIcon width={18} height="19" />
        </div>
      </Dropdown>
    </div>
  );
}
